import { Button } from "@src/appV2/redesign/components/Button";
import { Pill } from "@src/appV2/redesign/components/Pill";
import { Text } from "@src/appV2/redesign/components/Text";

interface AccountSwitcherOptionDesktopProps {
  title: string;
  subtitles?: string[];
  stage?: string;
  onClick?: () => void;
}

export function AccountSwitcherOptionDesktop(props: AccountSwitcherOptionDesktopProps) {
  const { title, subtitles, stage, onClick } = props;

  return (
    <Button
      fullWidth
      sx={{
        height: "auto",
        flexDirection: "column",
        alignItems: "start",
        border: "none",
      }}
      variant="outlineInverted"
      onClick={onClick}
    >
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.navbar?.itemContentSelected,
          fontWeight: 500,
        })}
      >
        {title}
      </Text>
      {subtitles?.map((subtitle) => (
        <Text
          key={subtitle}
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.navbar?.itemContent,
          })}
        >
          {String(subtitle)}
        </Text>
      ))}

      {stage && <Pill>{stage}</Pill>}
    </Button>
  );
}
